export default {
  'Submit': 'Soumettre',
  'Save': 'Enregistrer',
  'enterOTP': 'Entrez le code de vérification',
  'otpSent': 'Mot de passe à usage unique (OTP) envoyé',
  'login/signup': 'Se connecter/s’inscrire',
  'resendCode': 'Renvoyer le code',
  'edit': 'Modifier',
  'otpMessage': 'Un code à 6 chiffres a été envoyé sur votre numéro de téléphone.',
  'oyo360WelcomeMessage': 'Se connecter/s’inscrire',
  'oyo360ResendCode': 'Renvoyer le code',
  'oyo360Edit': 'Modifier',
  'oyo360otpMessage': 'Un code à 6 chiffres a été envoyé sur votre numéro de téléphone.',
  'buttonActionContinue': 'Continuer',
  'chooseLanguage': 'Choisir une langue',
  'currentLanguage': 'LANGUE ACTUELLE',
  'otherLanguages': 'AUTRES LANGUES',
  'google': 'Google',
  'facebook': 'Facebook',
  'or': 'ou',
  'buttonActionSubmit': 'Soumettre',
  'welcomeTitle': 'Bienvenue chez OYO',
  'welcomeHeadingForMailLogin': `Entrez l'adresse email associée`,
  'welcomeHeadingForPhoneLogin': 'Entrez le numéro de mobile associé',
  'emailIdLabel': 'Adresse email',
  'phoneNumberLabel': 'Numéro de téléphone',
  'passwordLabel': 'Mot de passe',
  'newPasswordLabel': 'Nouveau mot de passe',
  'confirmNewPasswordLabel': 'Confirmer le nouveau mot de passe',
  'emailErrorMessage': 'Veuillez entrer une adresse email correcte',
  'phoneNumberErrorMessage': 'Veuillez entrer un numéro de téléphone correct',
  'passwordErrorMessage': 'Veuillez entrer le bon mot de passe',
  'confirmPasswordErrorMessage': 'Le mot de passe ne correspond pas !',
  'generateNewPassword': 'Générer un nouveau mot de passe',
  'loginButtonLabel': 'Se connecter',
  'loginWithPhoneButtonLabel': 'Continuer avec le téléphone',
  'loginWithOtp': 'Se connecter avec un mot de passe à usage unique (OTP) à la place',
  'loginWithEmailButtonLabel': 'Continuer avec l’adresse email',
  'back': 'Retour',
  'loginWithOtpTitle': 'Entrez le code de vérification',
  'loginWithOtpHeading': 'Un code à 6 chiffres a été envoyé sur votre numéro de téléphone.',
  'listYourProperty': 'Mettez en ligne votre propriété',
  'privacyPolicy': 'politique de confidentialité',
  'verifyEmail': `Vérifier l'adresse email`,
  'verifyMobile': 'Vérifier le numéro de téléphone',
  'forgotPasswordPhoneSubHeading': 'Nous vous enverrons un code à 6 chiffres pour vérifier votre numéro de téléphone.',
  'forgotPasswordMailSubHeading': 'Nous vous enverrons un code à 6 chiffres pour vérifier votre adresse email.',
  'newPasswordCondition1': 'Doit comporter à la fois un chiffre et un symbole',
  'newPasswordCondition2': 'Doit avoir au moins 8 caractères',
  'newPasswordCondition3': 'Doit comporter à la fois des minuscules et des majuscules.',
  'confirmLogin': 'Confirmer et se connecter',
  'getOTP': 'Recevoir le mot de passe à usage unique (OTP)',
  'invalidInput': 'Saisie invalide',
  'passwordResetMessage': 'Mot de passe généré avec succès',
  'otpErrorMessage': 'Veuillez entrer le bon mot de passe à usage unique',
  'resendOtpSuccessMessage': 'Le mot de passe a été renvoyé avec succès sur votre numéro de mobile.',
  'InternalServerErrorMessage': 'Erreur de serveur interne',
  'resetPasswordHeading': 'Un code à 6 chiffres a été envoyé à votre adresse email et à votre numéro de téléphone.',
  'signingIn': 'Ouverture de la session',
  'invalidMobileNumber': 'Numéro de mobile invalide',
  'privacyFooterText': 'En vous connectant à votre compte, vous acceptez nos {termsOfUse} et notre {privacyPolicy}',
  'and': 'et',
  'termsOfUse': `conditions d'utilisation`,
  'listProperty': 'Propriété de la liste',
  'whiteSpace': ' ',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view'
};
